<template>
  <div class="d-flex flex-column min-vh-100">
    <AppHeader />
    
    <main class="container my-4 flex-grow-1">
      <router-view :key="$route.fullPath" />
    </main>
     <br/><br/><br/><br/>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader.vue'
import AppFooter from '../components/AppFooter.vue'

export default {
  components: { AppHeader, AppFooter }
};
</script>
